import { Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";

@Injectable()
export class CardDetailsFormBuilder {
  constructor(private fb: FormBuilder) {}

  private cardholderName = '';

  withCardholderName(cardholderName:string)
  {
    this.cardholderName = cardholderName;
    return this;
  }

  private cardDescription = '';

  withCardDescription(cardDescription:string)
  {
    this.cardDescription = cardDescription;
    return this;
  }

  private saveCardDetails = false;

  enableSaveCardDetails()
  {
    this.saveCardDetails = true;
    return this;
  }

  disableSaveCardDetails()
  {
    this.saveCardDetails = false;
    return this;
  }

 create() {
    return this.fb.group({
      name: [this.cardholderName, [Validators.required]],
      saveCardDetails: [this.saveCardDetails, []],
      cardDescription: [this.cardDescription, []]
    });
  }
}